module.exports = __webpack_public_path__ + "img/en05.08331ffa.png";